import React, { useState } from "react";
import { Spinner } from "reactstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Navigation, Thumbs } from "swiper/modules";
import SwiperCore from "swiper";

import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";

SwiperCore.use([FreeMode, Navigation, Thumbs]);

// Props added: featuredId, onFeature, onDelete, busyImageIds
const ImagePreview = ({
  images,
  featuredId = null,
  onFeature,
  onDelete,
  busyImageIds = new Set(),
}) => {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);

  if (!images || images.length === 0) {
    return (
      <div className="page-content text-center">
        <Spinner color="primary" />
        <p>Detalji o vozilu se učitavaju, molimo pričekajte...</p>
      </div>
    );
  }

  return (
    <div className="product-img-slider sticky-side-div">
      {/* Main viewer */}
      <Swiper
        className="swiper product-thumbnail-slider p-2 rounded bg-light"
        centeredSlides
        navigation
        thumbs={{ swiper: thumbsSwiper }}
      >
        <div className="swiper-wrapper">
          {images.map((image) => (
            <SwiperSlide
              key={image.id ?? image.url}
              style={{ padding: 0, maxWidth: 650, maxHeight: 400 }}
            >
              <div
                className="position-relative"
                style={{ width: "100%", height: "100%" }}
              >
                <img
                  className="img-fluid d-block w-100 h-100"
                  alt=""
                  src={image.url}
                  style={{ objectFit: "contain" }}
                />
                {/* Optional featured badge on main image */}
                {featuredId === image.id && (
                  <span className="position-absolute top-0 start-0 m-2 badge bg-warning text-dark">
                    <i className="ri-star-fill me-1" /> Glavna
                  </span>
                )}
              </div>
            </SwiperSlide>
          ))}
        </div>
      </Swiper>

      {/* Thumbnails with actions */}
      <Swiper
        className="swiper mt-4 overflow-hidden"
        onSwiper={setThumbsSwiper}
        slidesPerView={5}
        freeMode
        watchSlidesProgress
        spaceBetween={5}
      >
        <div className="swiper-wrapper">
          {images.map((image) => {
            const isFeatured = featuredId === image.id;
            const busy = busyImageIds.has(image.id);
            return (
              <SwiperSlide
                key={image.id ?? image.url}
                className="rounded avatar-md nav-slide-item"
                style={{ width: 100, height: 75 }}
              >
                <div className="position-relative w-100 h-100">
                  <img
                    className="img-thumbnail d-block rounded w-100 h-100"
                    alt=""
                    src={image.url}
                    style={{ objectFit: "cover" }}
                  />

                  <div className="position-absolute top-0 end-0 p-1 d-flex gap-1">
                    <button
                      type="button"
                      className={`btn btn-sm ${
                        isFeatured ? "btn-warning" : "btn-warning"
                      }`}
                      title={isFeatured ? "Glavna slika" : "Označi kao glavnu"}
                      disabled={busy || !onFeature}
                      onClick={(e) => {
                        e.stopPropagation();
                        onFeature?.(image);
                      }}
                    >
                      <i
                        className={isFeatured ? "ri-star-fill" : "ri-star-line"}
                      />
                    </button>
                    <button
                      type="button"
                      className="btn btn-sm btn-danger"
                      title="Obriši sliku"
                      disabled={busyImageIds.has(image.id)}
                      onClick={(e) => {
                        e.stopPropagation();
                        onDelete(image);
                      }}
                    >
                      <i className="ri-delete-bin-5-line" />
                    </button>
                  </div>
                </div>
              </SwiperSlide>
            );
          })}
        </div>
      </Swiper>
    </div>
  );
};

export default ImagePreview;
